import { render, staticRenderFns } from "./systemHome.vue?vue&type=template&id=b95a1e22&scoped=true"
import script from "./systemHome.vue?vue&type=script&lang=js"
export * from "./systemHome.vue?vue&type=script&lang=js"
import style0 from "./systemHome.vue?vue&type=style&index=0&id=b95a1e22&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b95a1e22",
  null
  
)

export default component.exports